import axios from "../../utils/axios";

export class GlaucomaReferralRefinementService {
  create(patientId: string, data: any) {
    return axios.post(`/patient/${patientId}/grr`, data);
  }

  get(patientId: string, grrId?: number) {
    const queryString = grrId ? `?grrId=${grrId}` : "";
    return axios.get(`/patient/${patientId}/grr${queryString}`);
  }

  update(patientId: string, id: number, data: any) {
    return axios.patch(`/patient/${patientId}/grr/${id}`, data);
  }
}